import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import SnapshotsControls from "layout/discovery/header/snapshots/SnapshotsControls";
import { exportAsCsv } from "slices/discovery/actions/theme";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { documentBy, FILTER_TYPES } from "constants/discovery";
import {
  getDocumentsWithTerms,
  getExtensions,
  getSelectedDocs,
  getSelectedTerms,
} from "layout/discovery/helpers";
import {
  selectConfig,
  selectDocuments,
  selectOccurrences,
  selectThemes,
} from "slices/discovery/selectors";

const RightPart = ({ documentView }) => {
  const themes = useSelector(selectThemes);
  const documents = useSelector(selectDocuments);
  const occurrences = useSelector(selectOccurrences);
  const isEmpty = occurrences === 0;
  const {
    folderId,
    documentBy: docBy,
    filterType,
    filterDocID,
  } = useSelector(selectConfig);
  const dispatch = useDispatch();

  const handleShredToExcel = () => {
    if (documents.length === 1) {
      /* For document view and folder view if folder contains only one document */

      const selectedDocs = getSelectedDocs(themes);
      const documentsWithTerms = getDocumentsWithTerms(
        selectedDocs,
        getSelectedTerms(themes),
        documentView && docBy === documentBy.content
      );

      dispatch(
        showModal(modalTypes.SHRED_TO_EXCEL, {
          documentsWithTerms,
          extensions: getExtensions(selectedDocs),
          exportContentOptionDisabled:
            documentView && docBy === documentBy.content,
        })
      );
    } else if (documents.length > 1) {
      /* For folder view if folder contains more then one document */

      dispatch(
        showModal(modalTypes.DISCOVERY_EXPORT_MULTIPLE_DOCS, {
          selectedTerms: getSelectedTerms(themes),
        })
      );
    }
  };

  const handleExportCSV = () => {
    let documentList = [];
    if (filterType === FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC) {
      documentList = themes[0]?.Documents.filter(
        (doc) => doc.Id === filterDocID
      ).map((doc) => ({ id: doc.Id, name: doc.Name }));
    } else {
      documentList = themes[0]?.Documents.filter((doc) => !doc.ignored).map(
        (doc) => ({ id: doc.Id, name: doc.Name })
      );
    }

    dispatch(exportAsCsv(folderId, documentList));
  };

  if (isEmpty) return null;

  // Document by content view
  if (documentView && docBy === documentBy.content) {
    return (
      <Button
        content="Shred to Excel"
        variant={buttonVariants.secondary}
        onClick={handleShredToExcel}
      />
    );
  }

  // Document by theme view, Folder view
  return (
    <>
      <SnapshotsControls />
      <Button
        content="Shred to Excel"
        variant={buttonVariants.secondary}
        onClick={handleShredToExcel}
      />
      <Dropdown
        type={dropdownTypes.buttons}
        propsObject={{
          button: <span>Export</span>,
          options: [
            <ButtonsDropdownOption
              content="Export Results (CSV)"
              onClick={handleExportCSV}
            />,
          ],
          buttonVariant: buttonVariants.secondary,
        }}
      />
    </>
  );
};

RightPart.propTypes = {
  documentView: PropTypes.bool.isRequired,
};

export default RightPart;
